<template>
   <div>
  <apexchart 
     width="100%" :height="chartHeight" :type="chartType" 
     :options="chartOptions" :series="chartData">
   </apexchart>  
   </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  props: {
    chartData: {
      required: true
    },
    chartOptions: {
      required: true
    },
    chartType: {
      required: true,
      default: 'bar'
    },
    chartHeight: {
      required: true,
      default: '350'
    }
  },
}
</script>